import React, { useEffect, useReducer, useState } from 'react';
import GameManager from '../cvp-webgames-core/GameManager';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import { globals } from '../misc/globals';
import { getSaveData } from '../misc/tools';
import DialogUI from './ui/DialogUI';
import HUDUI from './ui/hud/HUDUI';
import SBARUI from './ui/SBARUI';
import LoadedAssetsUI from '../cvp-webgames-core/Components/general/react/LoadedAssetsUI';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import ToolbagUI from './ui/ToolbagUI';
import AdministerMedsUI from './ui/AdministerMedsUI';
import NotificationUI from './ui/NotificationUI';
import BVMMakeAttemptUI from './ui/BVMMakeAttemptUI';
import BVMAttemptUI from './ui/BVMAttemptChooseHandUI';
import ArtifitialProgressUI from './ui/ArtifitialProgressUI';
import ETTSizeUI from './ui/ETTSizeUI';
import ETTMakeAttemptUI from './ui/ETTMakeAttemptUI';
import SGAMakeAttemptUI from './ui/SGAMakeAttemptUI';
import AuscultateUI from './ui/AuscultateUI';
import FloatingMessagesUI from './ui/FloatingMessagesUI';
import VortexJobAidUI from './ui/VortexJobAidUI';
import GeneralAlertUI from './ui/GeneralAlertUI';
import AssessAirwayUI from './ui/AssessAirwayUI';
import OptionsUI from './ui/OptionsUI';
import BVMOptimizationsUI from './ui/BVMOptimizationsUI';
import ETTOptimizationsUI from './ui/ETTOptimizationsUI';
import SGAOptimizationsUI from './ui/SGAOptimizationsUI';
import PalpateNeckUI from './ui/PalpateNeckUI';
import CricMakeAttemptUI from './ui/CricMakeAttemptUI';
import DebriefUI from './ui/DebriefUI';
import SideMenuUI from './ui/side-menu/SideMenu';
import PreOxygenateOptionsUI from './ui/PreOxygenateOptionsUI';
import DragToolsUI from './ui/DragToolsUI';
import { ScalpelUI } from './ui/ScalpelUI';
import InsertionAngleUI from './ui/InsertionAngleUI';
import EttOptionsUI from './ui/EttOptionsUI';
import DebugUI from './ui/DebugUI';
import Tools from '../cvp-webgames-core/Misc/Tools';
import EttSpecialUI from './ui/EttSpecialUI';
import ETTInstrumentInsertionUI from './ui/ETTInstrumentInsertionUI';
import SuccessFailedAttemptUI from './ui/SuccessFailedAttemptUI';
import VortexUI from './ui/hud/VortexUI';
import ETTResistanceUI from './ui/ETTResistanceUI';
import ReactCaption from '../cvp-webgames-core/Components/general/react/ReactCaption';
import { ClosedCaptionManager } from '../cvp-webgames-core/ClosedCaptionManager';

const reducer = (state: any, action: any) => {
	return state;
};

var ccManager: ClosedCaptionManager = null;
const UIOverlay = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});

	var isDisplayingHeader = false;

    (window as any).setCCManager = (ccM: any) => {
        ccManager = ccM;
        (window as any).forceUpdateInternalCCComp(); 
        // if((window as any).onCaptionsChanged) {
        //     (window as any).onCaptionsChanged();
        // }
    }


	useEffect(() => {
		$(window).resize();

		if(uisRegistered) {
			return;
		}

		(window as any)[constants.smeDebug.globalEvents.smeDebugUpdate] = [];

		var counter = 0;
        var interval = setInterval(() => {
            globals.queryMemory = true;
            counter++;
            if(counter >= 60) {
                clearInterval(interval);
            }
        }, 2000);

		setUisRegistered(true);

		var uiManager = props.gameManager.UiManager as JsxUIManager;

		uiManager.registerUI(constants.uiNames.HUDUI, {
			renderMethod: (instance: any) => {
				return <HUDUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></HUDUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.VortexUI, {
			renderMethod: (instance: any) => {
				return <VortexUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></VortexUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.ToolbagUI, {
			renderMethod: (instance: any) => {
				return (
					<div></div>
				)

				// return <ToolbagUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ToolbagUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.SideMenuUI, {
			renderMethod: (instance: any) => {
				return <SideMenuUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SideMenuUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.DraggedToolsUI, {
			renderMethod: (instance: any) => {
				return <DragToolsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></DragToolsUI>
			}
		});

		uiManager.registerUI(constants.uiNames.SBARUI, {
			renderMethod: (instance: any) => {
				return <SBARUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SBARUI>
			}
		});

		uiManager.registerUI(constants.uiNames.PreOxygenateOptionsUI, {
			renderMethod: (instance: any) => {
				return <PreOxygenateOptionsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></PreOxygenateOptionsUI>
			}
		});

		uiManager.registerUI(constants.uiNames.DialogUI, {
			renderMethod: (instance: any) => {
				return <DialogUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></DialogUI>
			}
		});

		uiManager.registerUI(constants.uiNames.AdminsterMedsUI, {
			renderMethod: (instance: any) => {
				return <AdministerMedsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></AdministerMedsUI>
			}
		});
		uiManager.registerUI(constants.uiNames.NotificationUI, {
			renderMethod: (instance: any) => {
				return <NotificationUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></NotificationUI>
			}
		});
		uiManager.registerUI(constants.uiNames.BVMMakeAttemptUI, {
			renderMethod: (instance: any) => {
				return <BVMMakeAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BVMMakeAttemptUI>
			}
		});
		uiManager.registerUI(constants.uiNames.ETTMakeAttemptUI, {
			renderMethod: (instance: any) => {
				return <ETTMakeAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ETTMakeAttemptUI>
			}
		});
		uiManager.registerUI(constants.uiNames.EttSpecialUI, {
			renderMethod: (instance: any) => {
				return <EttSpecialUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></EttSpecialUI>
			}
		});
		uiManager.registerUI(constants.uiNames.ETTInstrumentInsertionUI, {
			renderMethod: (instance: any) => {
				return <ETTInstrumentInsertionUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ETTInstrumentInsertionUI>
			}
		});
		uiManager.registerUI(constants.uiNames.BVMAttemptUI, {
			renderMethod: (instance: any) => {
				return <BVMAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BVMAttemptUI>
			}
		});
		uiManager.registerUI(constants.uiNames.ArtifitialProgressUI, {
			renderMethod: (instance: any) => {
				return <ArtifitialProgressUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ArtifitialProgressUI>
			}
		});
		uiManager.registerUI(constants.uiNames.ETTSizeUI, {
			renderMethod: (instance: any) => {
				return <ETTSizeUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ETTSizeUI>
			}
		});
		uiManager.registerUI(constants.uiNames.SGAMakeAttemptUI, {
			renderMethod: (instance: any) => {
				return <SGAMakeAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SGAMakeAttemptUI>
			}
		});
		uiManager.registerUI(constants.uiNames.AuscultateUI, {
			renderMethod: (instance: any) => {
				return <AuscultateUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></AuscultateUI>
			}
		});
		uiManager.registerUI(constants.uiNames.FloatingMessagesUI, {
			renderMethod: (instance: any) => {
				return <FloatingMessagesUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FloatingMessagesUI>
			}
		});
		uiManager.registerUI(constants.uiNames.VortexJobAidUI, {
			renderMethod: (instance: any) => {
				return <VortexJobAidUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></VortexJobAidUI>
			}
		});
		uiManager.registerUI(constants.uiNames.GeneralAlertUI, {
			renderMethod: (instance: any) => {
				return <GeneralAlertUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></GeneralAlertUI>
			}
		});
		uiManager.registerUI(constants.uiNames.AssessAirwayUI, {
			renderMethod: (instance: any) => {
				return <AssessAirwayUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></AssessAirwayUI>
			}
		});
		uiManager.registerUI(constants.uiNames.OptionsUI, {
			renderMethod: (instance: any) => {
				return <OptionsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></OptionsUI>
			}
		});
		uiManager.registerUI(constants.uiNames.BVMOptimizationsUI, {
			renderMethod: (instance: any) => {
				return <BVMOptimizationsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BVMOptimizationsUI>
			}
		});
		uiManager.registerUI(constants.uiNames.ETTOptimizationsUI, {
			renderMethod: (instance: any) => {
				return <ETTOptimizationsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ETTOptimizationsUI>
			}
		});
		uiManager.registerUI(constants.uiNames.SGAOptimizationsUI, {
			renderMethod: (instance: any) => {
				return <SGAOptimizationsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SGAOptimizationsUI>
			}
		});
		uiManager.registerUI(constants.uiNames.PalpateNeckUI, {
			renderMethod: (instance: any) => {
				return <PalpateNeckUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></PalpateNeckUI>
			}
		});
		
		uiManager.registerUI(constants.uiNames.CricMakeAttemptUI, {
			renderMethod: (instance: any) => {
				return <CricMakeAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></CricMakeAttemptUI>
			}
		});

		uiManager.registerUI(constants.uiNames.DebriefUI, {
			renderMethod: (instance: any) => {
				return <DebriefUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></DebriefUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ScalpelUI, {
			renderMethod: (instance: any) => {
				return <ScalpelUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ScalpelUI>
			}
		});

		uiManager.registerUI(constants.uiNames.InsertionAngleUI, {
			renderMethod: (instance: any) => {
				return <InsertionAngleUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></InsertionAngleUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ETTOptionsUI, {
			renderMethod: (instance: any) => {
				return <EttOptionsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></EttOptionsUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ETTResistanceUI, {
			renderMethod: (instance: any) => {
				return <ETTResistanceUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ETTResistanceUI>
			}
		});

		uiManager.registerUI(constants.uiNames.SuccessFailedAttemptUI, {
			renderMethod: (instance: any) => {
				return <SuccessFailedAttemptUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SuccessFailedAttemptUI>
			}
		});
	}, [state]);
	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-overlay-container in-game-ui-container ui-container-root modal-disable-select">
			{/* {props.gameManager.UiManager.render()} */}
			{props.gameManager.SoundManager.render()}
			{props.hideAllUIs ? (
				<div>

				</div>
			) : (
				<div>
					<SingleUI id={constants.uiNames.DialogUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.HUDUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.VortexUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ToolbagUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.SideMenuUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.DraggedToolsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.SBARUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.AdminsterMedsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.PreOxygenateOptionsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.NotificationUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.BVMMakeAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTMakeAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.EttSpecialUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTInstrumentInsertionUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.BVMAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ArtifitialProgressUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTSizeUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.SGAMakeAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.AuscultateUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.FloatingMessagesUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.VortexJobAidUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.GeneralAlertUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.AssessAirwayUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.OptionsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.BVMOptimizationsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTOptimizationsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.SGAOptimizationsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.PalpateNeckUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.CricMakeAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ScalpelUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.InsertionAngleUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTOptionsUI} uiManager={props.gameManager.UiManager}></SingleUI>

					<SingleUI id={constants.uiNames.ETTResistanceUI} uiManager={props.gameManager.UiManager}></SingleUI>
				</div>
			)}
			
			<SingleUI id={constants.uiNames.DebriefUI} uiManager={props.gameManager.UiManager}></SingleUI>
			<SingleUI id={constants.uiNames.SuccessFailedAttemptUI} uiManager={props.gameManager.UiManager}></SingleUI>
            <InternalCaptionComp></InternalCaptionComp>

			<DebugUI gameManager={props.gameManager} scenarioId={props.scenarioId} key={Tools.generateGuid()}></DebugUI>
		</div>
	) : (null);
};

export default UIOverlay;

const SingleUI = (props: SingleUIProps) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		if(!(window as any)[props.id]) {
			(window as any)[props.id] = {};
		}
		(window as any)[props.id]['main'] = () => {
			setForceUpdate(!forceUpdate);
		}
	})
	return (
		<div style={{
			position: 'absolute',
			pointerEvents: 'none',
			width: '100%',
			height: '100%',
			left: '0',
			top: '0'
		}}>
			{props.uiManager._uis.map((ui: any, uiIndx: number) => {
				if(ui.name !== props.id) {
					return null;
				}

				return ui.instances.map((instance: any, uiInstanceIndx: number) => {
					return <SingleUIInstance parentInstanceId={props.id} ui={ui} instance={instance}></SingleUIInstance>
				})
			})}
		</div>
	)
};

interface SingleUIProps {
	id: string;
	uiManager: JsxUIManager;
}

const SingleUIInstance = (props: SingleUIInstanceProps) => {
	const [updateCounter, setUpdateCounter] = useState(0);
	useEffect(() => {
		(window as any)[props.parentInstanceId][props.instance.id] = () => {
			setUpdateCounter(updateCounter+1);
		}
	})
	return (
		<div style={{
			position: 'absolute',
			pointerEvents: 'none',
			width: '100%',
			height: '100%',
			left: '0',
			top: '0'
		}}>
			{props.ui.uiData.renderMethod(props.instance)}
		</div>
	)
};

interface SingleUIInstanceProps {
	parentInstanceId: string;
	instance: any;
	ui: any;
}

const InternalCaptionComp = () => {
    const [forceUpdate, setForceUpdate] = useState(false);

    (window as any).forceUpdateInternalCCComp = () => {
        setForceUpdate(!forceUpdate);
    }

	if(typeof (window as any).CCEnabled === 'undefined') {
		(window as any).CCEnabled = true;
	}

    return ccManager ? (
        <div>
			{!(window as any).isDisplayingHud ? <ReactCaption
				currentCaption={ccManager.currentCaption}
				isPaused={ccManager.isPaused}
			></ReactCaption> : null}
            {ccManager && ccManager.currentCaption && !ccManager.isPaused && <div className="caption-container">
                    {(window as any).CCEnabled &&
                        <div className="caption-block">
                            <p tabIndex={0} className="caption-paragraph" dangerouslySetInnerHTML={{__html: ccManager.currentCaption}}>
                            </p>
                        </div>
                    }
                </div>
                }

        </div>
    ) : (null);

};